import script from "./NotifyComp.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyComp.vue?vue&type=script&setup=true&lang=js"

import "./NotifyComp.vue?vue&type=style&index=0&id=68d6dadf&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d6dadf"]])

export default __exports__